import { Collision } from '@dnd-kit/core';

import { DriveItemId } from '@/drive/entities/DriveItemId';
import { DriveSurface } from '@/drive/types/DriveSurface';

export interface DriveInsertion {
  surface: DriveSurface;
  targetId: DriveItemId;
  isAfter: boolean;
}

export function toInsertion(collisions: Nullable<Collision[]>): Nullable<DriveInsertion> {
  return (collisions?.[0]?.data?.insertion as DriveInsertion | undefined) ?? null;
}

export function isSameInsertion(left: Nullable<DriveInsertion>, right: Nullable<DriveInsertion>): boolean {
  if (!left || !right) {
    return left === right;
  }

  return left.surface === right.surface && left.targetId === right.targetId && left.isAfter === right.isAfter;
}

export function toInsertionIndex(insertion: DriveInsertion, oldIndex: number, targetIndex: number): number {
  const slotIndex = insertion.isAfter ? targetIndex + 1 : targetIndex;

  return oldIndex < slotIndex ? slotIndex - 1 : slotIndex;
}
